var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4877_918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3071 4.16665C15.1713 4.16985 15.0423 4.22664 14.9483 4.32461L9.99993 9.27297L5.05156 4.32461C5.00365 4.27527 4.94632 4.23604 4.88297 4.20925C4.81962 4.18246 4.75154 4.16866 4.68276 4.16866C4.58046 4.16868 4.48049 4.19923 4.39564 4.25639C4.3108 4.31355 4.24494 4.39472 4.20649 4.48952C4.16803 4.58432 4.15874 4.68844 4.17979 4.78855C4.20085 4.88866 4.25129 4.98022 4.32467 5.0515L9.27303 9.99987L4.32467 14.9482C4.27533 14.9956 4.23595 15.0523 4.20881 15.1151C4.18168 15.1779 4.16735 15.2455 4.16665 15.3138C4.16596 15.3822 4.17891 15.4501 4.20477 15.5134C4.23062 15.5767 4.26884 15.6342 4.3172 15.6826C4.36556 15.731 4.42309 15.7692 4.4864 15.795C4.54972 15.8209 4.61756 15.8338 4.68595 15.8331C4.75434 15.8324 4.8219 15.8181 4.88468 15.791C4.94746 15.7638 5.00419 15.7245 5.05156 15.6751L9.99993 10.7268L14.9483 15.6751C14.9957 15.7245 15.0524 15.7638 15.1152 15.791C15.178 15.8181 15.2455 15.8324 15.3139 15.8331C15.3823 15.8338 15.4501 15.8209 15.5135 15.795C15.5768 15.7692 15.6343 15.731 15.6827 15.6826C15.731 15.6342 15.7692 15.5767 15.7951 15.5134C15.8209 15.4501 15.8339 15.3822 15.8332 15.3138C15.8325 15.2455 15.8182 15.1779 15.791 15.1151C15.7639 15.0523 15.7245 14.9956 15.6752 14.9482L10.7268 9.99987L15.6752 5.0515C15.7499 4.97976 15.8013 4.8871 15.8224 4.78567C15.8436 4.68425 15.8337 4.57879 15.7939 4.48313C15.7541 4.38746 15.6863 4.30606 15.5994 4.24958C15.5125 4.19311 15.4106 4.1642 15.3071 4.16665Z",
    fill: "#0D5681"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4877_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7bf46e786abd799d5e54ee193f842f39.svg";
export { ForwardRef as ReactComponent };